module.exports = __webpack_public_path__ + "img/redbull.b0d1afae.png";